import { useNavigate } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import { useDataBoxEvents } from '@gov-nx/core/events';
import { useLocale } from '@gov-nx/core/service';
import { useDataBoxAccess, useDataBoxesContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';

export const DataBoxesNavigation = () => {
	const { t } = useLocale(PageCode['datove-schranky']);
	const { isSupportModalOpen } = useDataBoxesContext();
	const navigate = useNavigate();

	const { connect } = useDataBoxEvents();
	const { listToConnectTypes } = useDataBoxAccess({ requiredTypes: [] });

	return (
		<div className="flex flex-col gap-2 justify-center items-center w-full mt-auto [ xl:grow-0 xl:items-start ]">
			<nav
				aria-label={t('wcag.spodni-navigace')}
				className="w-full">
				<ul className="gov-list--plain flex flex-col gap-(--spacing-s-nudge) w-full">
					{listToConnectTypes.length ? (
						<li>
							<Button
								onClick={() => connect({ requiredTypes: listToConnectTypes })}
								color="primary"
								type="base"
								size="s"
								isExpanded
								className="hidden! ds-bottom-nav-item [ xl:block! ]"
								aria-label={t('schranky.pripojit-dalsi-datovku')}
								iconStart={
									<GovIcon
										name="plus-circle"
										type="templates"
									/>
								}>
								{t('schranky.pripojit-dalsi-datovku')}
							</Button>
						</li>
					) : null}
					<li>
						<Button
							onClick={() => navigate(pageRouteResolver(PageCode['nastaveni']))}
							color="primary"
							type="base"
							size="s"
							isExpanded
							className="hidden! ds-bottom-nav-item [ xl:block! ]"
							aria-label={t('schranky.nastaveni-datovky')}
							iconStart={
								<GovIcon
									name="gear"
									type="components"
								/>
							}>
							{t('schranky.nastaveni-datovky')}
						</Button>
						<Button
							onClick={() => navigate(pageRouteResolver(PageCode['nastaveni']))}
							color="primary"
							type="base"
							size="s"
							className="ds-bottom-nav-item [ xl:hidden! ]"
							aria-label={t('schranky.nastaveni-datovky')}
							iconStart={
								<GovIcon
									name="gear-fill"
									type="templates"
								/>
							}
						/>
					</li>
					<li>
						<Button
							onClick={isSupportModalOpen.setTrue}
							color="primary"
							type="base"
							size="s"
							isExpanded
							className="hidden! ds-bottom-nav-item [ xl:block! ]"
							aria-label={t('schranky.napoveda')}
							iconStart={
								<GovIcon
									name="question-circle"
									type="templates"
								/>
							}>
							{t('schranky.napoveda')}
						</Button>
						<Button
							onClick={isSupportModalOpen.setTrue}
							color="primary"
							type="base"
							size="s"
							className="ds-bottom-nav-item [ xl:hidden! ]"
							aria-label={t('schranky.napoveda')}
							iconStart={
								<GovIcon
									name="question-circle-fill"
									type="templates"
								/>
							}
						/>
					</li>
				</ul>
			</nav>
		</div>
	);
};
